import { IconLoader } from '@ui/src';
import { ProfitLossFrsTypes } from './types';
import ProfitLossFrsRow from './frs-row';

import cn from './profit-loss.module.css';

const ProfitLossFrs = ({ frs, isLoading, vatPercent }: ProfitLossFrsTypes) => {
  let content = (
    <div className={cn.reportLoader}>
      <IconLoader />
    </div>
  );

  if (!isLoading) {
    content = (
      <>
        <ProfitLossFrsRow title="Revenue" amount={frs?.revenue} bold />
        <ProfitLossFrsRow title="Cost of sales" amount={frs?.costOfSales} />
        <ProfitLossFrsRow title="Gross profit" amount={frs?.grossProfit} bold />
        <ProfitLossFrsRow
          title="Administrative expenses"
          amount={frs?.adminExpenses}
        />
        <ProfitLossFrsRow
          title="Operating profit"
          amount={frs?.operatingProfit}
          bold
        />
        <ProfitLossFrsRow
          title="Interest receivable and similar income"
          amount={frs?.interestReceivable}
        />
        <ProfitLossFrsRow title="" amount={frs?.profitInterestSum} />
        <ProfitLossFrsRow
          title="Interest payable and similar expenses"
          amount={frs?.interestPayable}
        />
        <ProfitLossFrsRow
          title="Profit before taxation"
          amount={frs?.profitBeforeTaxes}
          bold
        />
        <ProfitLossFrsRow
          title={
            <div className={cn.profitLossRowTitleWithHint}>
              {`Tax on profit (${vatPercent}%)`}
              <div className={cn.profitLossFrsHint}>i</div>
            </div>
          }
          amount={frs?.taxSum}
        />
        <ProfitLossFrsRow
          title="Profit for the financial year"
          amount={frs?.profitFinYear}
          bold
        />
        <ProfitLossFrsRow
          title="Other comprehensive income "
          amount={frs?.otherComprehensiveIncome}
          bold
        />
        <ProfitLossFrsRow
          title="Total comprehensive income for the year"
          amount={frs?.totalComprehensiveIncomeForYear}
          bold
        />
      </>
    );
  }

  return (
    <>
      <div className={cn.profitLossFrsHeader}>
        <div className={cn.profitLossFrsHeaderValue}>Description</div>
        <div className={cn.profitLossFrsHeaderValue}>Amount in BC</div>
      </div>
      {content}
    </>
  );
};

export default ProfitLossFrs;
